import React from 'react';
// import PropTypes from 'prop-types'
import { LoadingStyled } from './styled';
import cx from 'classnames';
import * as Loader from "react-loader-spinner";

const Loading = ({
  theme_standard_loading,
  // type = 'Puff',
  color = '#307E8D',
  height = 70,
  width = 70,
  timeout
}) => {
  const customClass = cx({
    theme_standard_loading: theme_standard_loading,
  });

  return (
    <LoadingStyled>
      <div className={customClass}>
        <Loader.Oval
          color={color}
          height={height}
          width={width}
          timeout={timeout} //3 secs
        />
      </div>
    </LoadingStyled>
  );
};

Loading.propTypes = {};

export default Loading;
